import React from "react";
import { Card, CardColumns, Container, Button, Modal } from "react-bootstrap";
import CarouselSei from "./CarouselSei";
import BannerTitles from "./BannerTitles";
import SeismicMiniCara from "./SeismicMiniCara";

let animationArray = ["cardMoveInTop", "cardMoveInBottom", "cardMoveInLeft", "cardMoveInRight"];

let seismic = [
	{
		name: "Bartlett, San Francisco, CA",
		images: ["Bartlett, San Francisco, CA1.jpg-Bartlett, San Francisco, CA2.jpg"]
	},
	{
		name: "Country Club Dr, South San Francisco, CA",
		images: ["Country Club Dr, South San Francisco, CA1.jpg-Country Club Dr, South San Francisco, CA2.jpg"]
	},
	{
		name: "Francisco St, San Francisco, CA",
		images: ["Francisco St, San Francisco, CA1.jpg-Francisco St, San Francisco, CA2.jpg"]
	},
	{
		name: "Franklin St San Francisco, CA",
		images: ["Franklin St San Francisco, CA1.jpg"]
	},
	{
		name: "Mallorca Way, San Francisco, CA",
		images: ["Mallorca Way, San Francisco, CA1.jpg-Mallorca Way, San Francisco, CA2.jpg"]
	},
	{
		name: "Steiner St, San Francisco, CA",
		images: ["Steiner St, San Francisco, CA1.jpg"]
	}
];
let imgPath = require.context("../../public/images/seismic", true);

const titleMap = {
	"Bartlett, San Francisco, CA": "Bartlett Building",
	"Country Club Dr, South San Francisco, CA": "Country Club Drive Building",
	"Francisco St, San Francisco, CA": "Francisco Street Building",
	"Franklin St San Francisco, CA": "Franklin Street Building",
	"Mallorca Way, San Francisco, CA": "Mallorca Way Building",
	"Steiner St, San Francisco, CA": "Steiner Street Building"
};

const locationMap = {
	"Bartlett, San Francisco, CA": "San Francisco, CA",
	"Country Club Dr, South San Francisco, CA": "South San Francisco, CA",
	"Francisco St, San Francisco, CA": "San Francisco, CA",
	"Franklin St San Francisco, CA": "San Francisco, CA",
	"Mallorca Way, San Francisco, CA": "San Francisco, CA",
	"Steiner St, San Francisco, CA": "San Francisco, CA"
};

const getLocation = name => locationMap[name] || name;
const getProjectTitle = name => titleMap[name] || name;

const Seismic = props => {
	return (
		<Container fluid className="p-0">
			<BannerTitles title={"Seismic Retrofit"} />
			<SeismicMiniCara />
			<Container className="col-12 col-md-9">
				<CardColumns>
					{seismic.map((build, idx) => {
						let time = Math.random() * 4;
						let num = Math.floor(Math.random() * Math.floor(4));
						let name = animationArray[num];
						let imgStyle = { animation: `${name} ${time}s` };
						let imgSrc = imgPath("./" + `${build.name}` + "1.jpg");

						return (
							<Card className="gallery-card" style={imgStyle} key={idx}>
								<Card.Img src={imgSrc}></Card.Img>
								<Card.ImgOverlay className="gallery-overlay">
									<Button onClick={props.handleClick} value={build.name} name={build.images} className="gallery-view-button">
										View
									</Button>
								</Card.ImgOverlay>
								<Card.Body>
									<Card.Title>{getProjectTitle(build.name)}</Card.Title>
									<Card.Text>Seismic Retrofit | {getLocation(build.name)}</Card.Text>
								</Card.Body>
							</Card>
						);
					})}
				</CardColumns>

				<Modal show={props.show} onHide={props.closeModal} container={this} dialogClassName="modal-90w" aria-labelledby="contained-modal-title">
					<Modal.Header closeButton className="lightbox-header" />
					<Modal.Body className="mx-auto" style={{ width: "100%" }}>
						<CarouselSei images={props.imgs} />
					</Modal.Body>
				</Modal>

				<hr className="my-5" />
			</Container>
		</Container>
	);
};

export default Seismic;
